@for (modal of modals; track $index) {
<ng-container>
  <div
    class="backdrop-blur-sm transition duration-400 h-full w-full fixed left-0 top-0 flex justify-center items-center bg-black/50 transition-opacity duration-500 ease-out"
    [style.zIndex]="baseZIndex + $index * 2" [ngClass]="{
      'opacity-0': !modal.options.isOpen,
      'opacity-100': modal.options.isOpen
    }" [class]="modal.options.variant!">
    <div class="bg-white flex flex-col max-h-9/10 rounded-lg transition-all duration-300 transform"
      [class]="getModalSize(modal.options.size)" [ngClass]="{
        'scale-95': !modal.options.isOpen,
        'scale-100': modal.options.isOpen,
        'opacity-0': !modal.options.isOpen,
        'opacity-100': modal.options.isOpen
      }">
      <div class="p-10 relative overflow-hidden" [ngClass]="{
          'flex justify-between border-b-1 border-[#D0D5DD]':
            modal.options.style === 'modal'
        }">
        @if(modal.options.style === 'alert') {
        <div class="flex justify-end pb-10">
          <div
            class="-left-30 -top-30 absolute border border-1 rounded-full size-85 flex items-center justify-center border-[#EAECF0]/20">
            <div class="border border-1 rounded-full size-70 flex items-center justify-center border-[#EAECF0]/40">
              <div class="border border-1 rounded-full size-55 flex items-center justify-center border-[#EAECF0]/60">
                <div class="border border-1 rounded-full size-40 flex items-center justify-center border-[#EAECF0]/80">
                  <div class="border border-1 rounded-full size-25 flex items-center justify-center border-[#EAECF0]">
                    <div class="bg-(--scheme-bg) size-12 rounded-full flex items-center justify-center">
                      <i class="icon !text-2xl text-(--scheme-color)" [ngClass]="'icon-' + modal.options.icon"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ng-container *ngTemplateOutlet="closeButtonTemplate" />
        </div>
        }
        <div class="flex items-center z-5 relative">
          @if(modal.options.style === 'modal') {
          <div class="bg-[#F2F4F7] size-14 rounded-full flex items-center justify-center">
            <i class="icon !text-3xl" [ngClass]="'icon-' + modal.options.icon"></i>
          </div>
          }
          <div class="ms-3">
            <h5 class="text-[#100B01] text-xl font-bold mb-2">
              {{ modal.options.title }}
            </h5>
            <div class="text-[#66635D] text-sm">
              {{ modal.options.description }}
            </div>
          </div>
        </div>
        @if(modal.options.style === 'modal') {
        <ng-container *ngTemplateOutlet="closeButtonTemplate" />
        }
      </div>
      <ng-template #closeButtonTemplate>
        <button data-testid="modal-close" class="p-2 cursor-pointer" (click)="close(modal, modalEventType.CLOSED)">
          <i class="icon icon-x-close hover:bg-gray-200 p-2 rounded-full"> </i>
          <span class="sr-only">Fechar modal</span>
        </button>
      </ng-template>

      @if (modal.content) {
      <div [class.overflow-y-auto]="modal.options.enableScroll"
        [class.p-10]="modal.options.hasCancellation || modal.options.hasConfirmation">

        @if (isTemplate(modal.content)) {
        <ng-container *ngTemplateOutlet="modal.content"></ng-container>
        } @else {
        <ng-container *ngComponentOutlet="modal.content; inputs: modal.options.componentInputs"></ng-container>
        }
      </div>
      }
      @if (modal.options.hasCancellation || modal.options.hasConfirmation) {
      <div class="px-10 py-5 flex items-center justify-between" [ngClass]="{
          'border-t-1 border-[#D0D5DD]': modal.options.style === 'modal',
          'justify-between': modal.options.hasCancellation && modal.options.hasConfirmation,
          'justify-end': !(modal.options.hasCancellation && modal.options.hasConfirmation)
        }">
        @if (modal.options.hasCancellation) {
        <button data-testid="modal-cancelletion" [disabled]="modal.options.cancellationLoading"
          (click)="handleModalAction(modal, modalEventType.CANCELLED)"
          class="disabled:opacity-80 bg-[#03212C1F] text-[#26434D] hover:text-[#D0343F] hover:bg-[#FFE0E0] font-semibold py-3 px-8 text-center rounded-md transition-colors duration-300">
          @if(modal.options.cancellationLoading) {
          <app-spinner />
          }
          {{ modal.options.cancellationLabel }}
        </button>
        } @if(modal.options.hasConfirmation) {
        <button data-testid="modal-confirmation" (click)="handleModalAction(modal, modalEventType.CONFIRMED)"
          [disabled]="modal.options.confirmationDisabled || modal.options.confirmationLoading" [ngClass]="{
            'bg-[#100B01] hover:bg-[#EAAA08] rounded-md': modal.options.style === 'modal',
            'bg-(--scheme-normal) hover:bg-(--scheme-color) rounded-lg': modal.options.style === 'alert'
          }"
          class="disabled:opacity-80 text-[#fff] font-semibold py-3.5 px-8 text-center transition-colors duration-300">
          @if(modal.options.confirmationLoading) {
          <app-spinner />
          }
          {{ modal.options.confirmationLabel }}
        </button>
        }
      </div>
      }
    </div>
  </div>
</ng-container>
}